import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import moment from 'moment';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { makeStyles, TextField, Select, MenuItem, Paper, Grow } from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TileLayers from './TileLayers';
import WMSLayers from './WMSLayers';
import { useLeaflet } from 'hooks';

const useStyle = makeStyles((theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  item: {
    textDecoration: 'none',
  },
  itemText: {
    color: theme.palette.text.primary,
  },
  list: {
    width: 260,
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
    zIndex: 801,
  },
  select: {
    zIndex: 801,
  },
  toggle: {
    position: 'absolute',
    right: 10,
    top: 10,
    width: 40,
    height: 40,
    margin: 10,
    borderRadius: '50%',
    background: 'rgba(255,255,255, 0.7)',
    padding: theme.spacing(1),
    zIndex: 801,
    '&:hover': {
      background: 'rgba(255,255,255, 0.85)',
    },
  },
  toolbar: {
    background: 'rgba(255,255,255, 0.8)',
    position: 'absolute',
    right: 60,
    top: 10,
    zIndex: 801,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
  },
}));

const MapOptions = () => {
  const { baseLayer, dataLayer, opacity, setBaseLayer, setDataLayer, setOpacity, mapDate, setMapDate } = useLeaflet();
  const classes = useStyle();
  const { t } = useTranslation();
  const [open, setOpenState] = useState(false);

  const setOpen = (val) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log('Setting Layers VAL', val);
    }
    val.stopPropagation();
    val.preventDefault();
    setOpenState(!open);
  };

  return (
    <div style={{ display: 'block' }}>
      <div className={classes.toggle} onMouseUp={setOpen}>
        <LayersIcon size="large" style={{ color: '#555555' }} />
      </div>
      <Grow in={open} style={{ transformOrigin: 'right 10px' }}>
        <Paper elevation={3} className={classes.toolbar}>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="baseLayer">{t('base_layer')}</InputLabel>
            <Select
              value={baseLayer}
              className={classes.select}
              onChange={(event) => setBaseLayer(event.target.value)}
              inputProps={{
                name: 'baseLayer',
                id: 'baseLayer',
              }}
            >
              {_.map(TileLayers.layers, (layer, name) => (
                <MenuItem key={name} value={name}>
                  {layer.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="dataLayer">{t('wms_layer')}</InputLabel>
            <Select
              value={dataLayer}
              onChange={(event) => setDataLayer(event.target.value)}
              inputProps={{
                name: 'dataLayer',
                id: 'dataLayer',
              }}
            >
              <MenuItem value="none">{t('none')}</MenuItem>
              {_.map(WMSLayers.layers, (layer, name) => (
                <MenuItem key={name} value={name}>
                  {layer.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="date"
            label={t('overlay_date')}
            type="date"
            variant="standard"
            defaultValue={mapDate}
            className={classes.formControl}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => setMapDate(event.target.value)}
          />
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="opacity">{t('opacity')}</InputLabel>
            <Select
              value={opacity}
              onChange={(event) => setOpacity(event.target.value)}
              inputProps={{
                name: 'opacity',
                id: 'opacity',
              }}
            >
              <MenuItem value={10}>0.1</MenuItem>
              <MenuItem value={20}>0.2</MenuItem>
              <MenuItem value={30}>0.3</MenuItem>
              <MenuItem value={40}>0.4</MenuItem>
              <MenuItem value={50}>0.5</MenuItem>
              <MenuItem value={60}>0.6</MenuItem>
              <MenuItem value={70}>0.7</MenuItem>
              <MenuItem value={80}>0.8</MenuItem>
              <MenuItem value={90}>0.9</MenuItem>
              <MenuItem value={100}>1.0</MenuItem>
            </Select>
          </FormControl>
        </Paper>
      </Grow>
    </div>
  );
};

MapOptions.propTypes = {};

MapOptions.defaultProps = {};

export default MapOptions;
